import script from "./SerpOqlPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SerpOqlPanel.vue?vue&type=script&setup=true&lang=js"

import "./SerpOqlPanel.vue?vue&type=style&index=0&id=e07fd73a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e07fd73a"]])

export default __exports__